import { Task } from '../types';

export const sampleTasks: Task[] = [
  {
    id: 't1',
    dealId: 'deal-1',
    title: 'Complete Technical Due Diligence',
    description: 'Review all technical documentation and systems',
    status: 'in_progress',
    priority: 'high',
    dueDate: '2024-04-15',
    assignee: 'John Smith',
    category: 'technical'
  },
  {
    id: 't2',
    dealId: 'deal-1',
    title: 'Financial Model Review',
    description: 'Review and validate financial projections',
    status: 'pending',
    priority: 'high',
    dueDate: '2024-04-20',
    assignee: 'Sarah Johnson',
    category: 'financial'
  },
  {
    id: 't3',
    dealId: 'deal-2',
    title: 'Legal Documentation Review',
    description: 'Review all legal agreements and contracts',
    status: 'pending',
    priority: 'medium',
    dueDate: '2024-04-25',
    assignee: 'Emily Rodriguez',
    category: 'legal'
  }
];